import { TransProp } from "@icc/shared/helpers";
import { Cord } from "./cord";
import { Guide } from "./guide";

/** Prowadzenia */
export class Guides {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /** Lewe prowdzenie.
     * 
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null` 
     */
    @TransProp(Guide)
    left: Guide | Cord | null;
    /** 
     * Prawe prowadzenie
     * 
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp(Guide)
    right: Guide | Cord | null;
}
